import IntegrationProvider from '@/integrations/IntegrationProvider'

const useFigma = () => {
  const provider = new IntegrationProvider('figma')

  const connect = () => {
    return provider.authenticate()
  }

  const authorize = (state: { [key: string]: any } = {}) => {
    return provider.authorize(state)
  }

  return {
    connect,
    authorize,
  }
}

export default useFigma
